module.exports = __webpack_public_path__ + "src/assets/games/19/251.jpg";